<template>
  <div>
      <v-row>
        <v-col class="pl-7">
          <div class="primary1--text headline font-weight-bold">
            GERENCIAMENTO DE TOKEN
          </div>
        </v-col>
      </v-row>
    <TabelaGerenciamentoToken/>
  </div>
</template>

<script>
import TabelaGerenciamentoToken from './Shared/TabelaGerenciamentoToken'

export default {
  components: {
    TabelaGerenciamentoToken
  }
}
</script>

<style>
</style>
